import { Button, Grid, Typography } from '@mui/material';
import { useCallback } from 'react';

import { useAppStore } from '@/modules/app/store/useAppStore';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { logger } from '@common/logging/logger';

import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';

export const LogSelectedElementsButton = () => {
  const selectedIds = useAppStore((state) => state.selectedIds);

  const handleClick = useCallback(() => {
    const { getAreasByIds, interAreaConnectionActions } = useFloorplanDesignStore.getState();
    const areas = getAreasByIds(selectedIds);
    const connections = interAreaConnectionActions.getRelatedTo(selectedIds);

    logger.info('[Debug] Selected IDs', selectedIds);
    logger.info('[Debug] Selected areas', areas);
    logger.info('[Debug] Related connections', connections);
  }, [selectedIds]);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Log selected elements</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Button onClick={handleClick}>Click</Button>
      </Grid>
    </>
  );
};
